/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Usage_S42_Item_1Inputs */

const es_privacy_policy_usage_s42_item_1 = /** @type {(inputs: Privacy_Policy_Usage_S42_Item_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analizar el uso de caracteristicas para hacer Nexata mas util`)
};

const en_privacy_policy_usage_s42_item_1 = /** @type {(inputs: Privacy_Policy_Usage_S42_Item_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze feature usage to make Nexata more useful`)
};

/**
* | output |
* | --- |
* | "Analyze feature usage to make Nexata more useful" |
*
* @param {Privacy_Policy_Usage_S42_Item_1Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_usage_s42_item_1 = /** @type {((inputs?: Privacy_Policy_Usage_S42_Item_1Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Usage_S42_Item_1Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_usage_s42_item_1(inputs)
	return en_privacy_policy_usage_s42_item_1(inputs)
});
export { privacy_policy_usage_s42_item_1 as "privacy_policy.usage.s42_item_1" }